import "../../styles/a.css";

interface AProps {
    text: string;
    href: string;
    target?: "_blank" | "_parent" | "_self" | "_top";
}

export const A = ({ text, href, target }: AProps) => {
    return (
        <a className="a" href={href} target={target}>
            {text} &rsaquo;
        </a>
    );
};
